// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b9e7a743","455":"7e24fe1a","644":"0c6098b5"}[chunkId] + ".chunk.js";
};